export default __webpack_public_path__ + "static/media/prevarrow.0e48cbb4.svg";